import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { getArticlesByCategory } from '@/utils/content';

export default function EditorPicksSection() {
  const picks = [
    ...getArticlesByCategory('quannei'),
    ...getArticlesByCategory('diantai'),
    ...getArticlesByCategory('shehui'),
  ].slice(0, 6);

  return (
    <section id="picks" className="mx-auto w-full scroll-mt-24 px-4 py-14 md:px-10 md:py-20">
      <SectionHeading
        kicker="EDITOR'S PICK · 编辑精选"
        title="不追热搜的时候，我们读这些"
        description="来自从业者的自述、夜班人群的来信与社会观察，节奏慢一些，信息量不减。"
        morePath="/category/quannei"
        moreLabel="进入圈内实录"
      />

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {picks.map((item) => (
          <ArticleCard key={item.id} article={item} variant="standard" />
        ))}
      </div>
    </section>
  );
}